import { render, staticRenderFns } from "./justAddWater.vue?vue&type=template&id=f54ac17c&"
import script from "./justAddWater.vue?vue&type=script&lang=js&"
export * from "./justAddWater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports